import React from 'react';

import Contenslider from './Contentsslider';
import heroBg from '../../Assets/elvotaimages/Hero-bg.png';

export default function Bess() {
  return (
    <div className="Hero-bg" style={{ backgroundImage: `url(${heroBg})` }}>
      <div className="parent-container flex flex-col justify-end h-full">
        <div
          className="main-container mx-auto pt-0"
          style={{ paddingBottom: '5%' }}
        >
          <div className="powering-bg w-full lg:w-[837px] py-6 px-[35px] flex flex-col">
            <div className="mt-auto pb-2">
              <Contenslider />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
